import { Initiative, MonthlyImpactMap } from "aint-types";

export function roundFteImpact(initiative: Initiative) {
  const roundFte = (fte: MonthlyImpactMap) => {
    if (!fte) {
      return;
    }

    Object.entries(fte).forEach(([year, impactByMonth]) => {
      Object.entries(impactByMonth).forEach(([month, impact]) => {
        // Using Math.round in combination with Number.EPSILON is the most accurate way of rounding I have found.
        // Both Math.round on its own and Number.toFixed have some flaws that get circumvented this way.
        fte[year][month] = impact
          ? (
              Math.round((Number(impact) + Number.EPSILON) * 100) / 100
            ).toString()
          : impact;
      });
    });
  };

  roundFte(initiative.internalFteImpactActual as MonthlyImpactMap);
  roundFte(initiative.internalFteImpactPlanned as MonthlyImpactMap);
  roundFte(initiative.externalFteImpactActual as MonthlyImpactMap);
  roundFte(initiative.externalFteImpactPlanned as MonthlyImpactMap);
}
